<div class="near-searchbar">
    <div class="logo-small float-end" routerLink="/"></div>
</div>

<google-map #googleMap height="100vh" width="100%" [mapTypeId]="mapTypeId" [options]="options">
    @if (area) {
        @for (building of area.buildings; track building) {
            <map-marker
                [position]="building.locatie | latLngPosition"
                [icon]="'building-label' | mapMarker: building.housenumber">
            </map-marker>
        }
        @if (area.exteriorRing?.length > 3) {
            <map-polygon [paths]="area.exteriorRing" [options]="polygonOptions"></map-polygon>
        }
    }
</google-map>
